import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { sanitize } from "isomorphic-dompurify";
import { CasPurposesApi } from "@jti/rest-api";
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import { FormField, Label, useFormContext } from "../../../../components/Form";
import { MarkdownWrapper } from "../../../../components/MarkdownWrapper";
import { useUser } from "../../../../hooks/useUser";
import { useConfig } from "../../../../providers/useConfig";
import { replaceOneTrustPlaceholdersWithLinks } from "../../../../utils/linkReplacer/linkReplacer";
import { stripHtmlTags } from "../../../../utils/stripHtmlTags/stripHtmlTags";
import styles from "../../CommonContactForm.module.scss";
import checkboxStyles from "./ConsentCheckbox.module.scss";
export const ConsentCheckbox = ({ displayConsent, dataTestId = "formConsentCheckbox", consent = "contact_form", namePrefix = "", }) => {
    const config = useConfig();
    const [checkboxes, setCheckboxes] = useState([]);
    const { isUserLoggedIn } = useUser();
    const { setValue } = useFormContext();
    const isConsentCheckboxHidden = (displayConsent === "onlyLoggedIn" && !isUserLoggedIn) || (displayConsent === "onlyNotLoggedIn" && isUserLoggedIn);
    useEffect(() => {
        if (!isConsentCheckboxHidden) {
            CasPurposesApi.init()
                .getPurposesByStep(consent)
                .then((response) => {
                const sanitizedResponse = response.map((element) => {
                    const name = namePrefix ? [namePrefix, element.id].join(".") : element.id;
                    setValue(`${name}.language`, element.language);
                    return {
                        id: element.id,
                        name,
                        description: element.description,
                        mandatory: element.mandatory,
                        default: element.default,
                    };
                });
                setCheckboxes(sanitizedResponse);
            });
        }
    }, [isConsentCheckboxHidden]);
    if (isConsentCheckboxHidden) {
        return null;
    }
    return (_jsx("div", { className: checkboxStyles.container, children: checkboxes.map((element, key) => {
            const sanitizedDescription = sanitize(config.ONE_TRUST_DYNAMIC_LINKS
                ? replaceOneTrustPlaceholdersWithLinks(element.description, config.ONE_TRUST_DYNAMIC_LINKS ?? [])
                : element.description, { ADD_ATTR: ["target"] });
            return (_jsx(FormField, { dataTestId: dataTestId, renderLabel: () => (_jsx(Label, { id: element.id, label: _jsx("div", { className: checkboxStyles.checkboxLabel, children: _jsx(MarkdownWrapper, { children: sanitizedDescription }) }), required: element.mandatory, checkable: true, showRequiredAsterisk: false })), className: classNames(styles.formField, checkboxStyles.checkboxContainer), name: element.name, id: element.id, validation: {
                    validate: (value) => !!value?.checked,
                }, showCustomError: true, render: ({ field, fieldState: { error } }) => (_jsx(Checkbox, { ...field, "aria-label": stripHtmlTags(sanitizedDescription), labelHtml: "", required: element.mandatory, id: element.id, checked: element.default, isError: !!error, errorText: error?.message, isHelperTextVisible: true })) }, key));
        }) }));
};
//# sourceMappingURL=ConsentCheckbox.js.map